<script>
import IconCart from "@js/components/Icons/IconCart.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "CartEmpty",
    components: {IconCart, Link}
}
</script>

<template>
    <div class="flex flex-col items-start md:items-center justify-center w-full bg-white p-5 md:p-10 border border-gray-200 shadow rounded-xl">
        <div class="flex items-start md:items-center justify-center border border-gray-200 rounded-full p-3 md:p-4 mb-2 md:mb-5">
            <IconCart class="w-3 md:w-5 h-3 md:h-5 text-gray-800"/>
        </div>
        <div class="text-xl md:text-2xl font-bold text-gray-800 text-center mb-2">
            Корзина пустая
        </div>
        <div class="text-sm md:text-base font-medium text-gray-800 text-start md:text-center">
            Вы можете выбрать нужный вам товар в нашем
            <Link :href="route('catalog')" class="font-bold underline hover:text-indigo-600 transition">
                Каталоге
            </Link>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
